import { motion } from "framer-motion";

const COLS = [
  {
    n: "01",
    title: "ATTRACT",
    body: "Turn the right attention into qualified conversations with clear offers and conversion-focused campaigns.",
  },
  {
    n: "02",
    title: "FOLLOW UP",
    body: "Make every lead feel seen with timely, consistent communication instead of manual chase-down.",
  },
  {
    n: "03",
    title: "AUTOMATE",
    body: "Connect the handoffs, reminders, and reporting that keep momentum moving after the first touch.",
  },
];

export default function ReplayOperatingSystem() {
  return (
    <section
      className="relative py-28 md:py-40 border-t wam-hairline"
      data-testid="replay-os"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="mb-10 flex items-center gap-4"
        >
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#F0ECE4]/40">
            [002] —
          </span>
          <span className="font-mono text-[11px] tracking-[0.3em] text-[#C9A84C]">
            THE SYSTEM
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="font-display max-w-[1000px]"
          style={{ fontSize: "clamp(32px, 4.4vw, 66px)", lineHeight: 0.95, letterSpacing: "-0.03em" }}
        >
          The SBA <span className="text-[#C9A84C]">operating system.</span>
        </motion.h2>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6">
          {COLS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="relative border-t wam-hairline pt-8 md:pt-10"
              data-testid={`replay-os-col-${i}`}
            >
              {/* Huge faded number */}
              <div
                aria-hidden
                className="pointer-events-none absolute -top-4 -right-2 font-display select-none"
                style={{
                  fontSize: "clamp(96px, 12vw, 200px)",
                  lineHeight: 1,
                  letterSpacing: "-0.05em",
                  color: "transparent",
                  WebkitTextStroke: "1px rgba(240,236,228,0.06)",
                }}
              >
                {c.n}
              </div>
              <div className="relative">
                <div className="font-mono text-[10px] tracking-[0.28em] text-[#C9A84C]">
                  / {c.n}
                </div>
                <div className="mt-3 font-display text-[26px] md:text-[32px] tracking-[-0.03em] leading-none">
                  {c.title}
                </div>
                <p className="mt-5 max-w-[320px] font-body text-[14px] leading-[1.7] text-[#F0ECE4]/60">
                  {c.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
